export default "/images/vendor/flag-icons/flags/1x1/et.svg?0dc087ac2ca4963059fe210fda85bbf1";